// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"9f8b421843554939","4795":"0a98a96be5ab01b6"}[chunkId] + ".css";
};